import * as React from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export default function Alerts({ openSnack, setWhenOpen, type, msg }) {

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;

    setWhenOpen(false);
  };

  return (
    <Snackbar
      open={openSnack}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert severity={type}>{msg}</Alert>
    </Snackbar>
  );
}
